import * as React from 'react';

import { OptionsComponent } from './Checkboxes';

export const MultipleChoice: QuestionCardBodyComponent = (props) => {
  return <OptionsComponent bulletClass='rounded-full' {...props} />;
};
